<template>
    <div class="panel panel-default consumption-form">
        <div class="panel-heading separator">
            <div class="panel-title">Ajout de produit
            </div>
        </div>
        <error-notification v-if="anyError"
                            :error="formError"></error-notification>
        <div class="panel-body">
            <div class="alert alert-warning" style="margin-bottom: 0;"
                 v-if="hasActiveMailForwardingPackage">
                Ce client dispose d'un forfait réexpédition actif inclus dans son contrat de domiciliation.
            </div>

            <div class="form-group-attached p-t-10">

                <div class="row clearfix">
                    <div class="col-sm-4"
                         v-if="agencies.length">
                        <div class="form-group form-group-default required">
                            <label>Agence</label>
                            <select2 :classList="['full-width', 'form-control']"
                                     :options="agencies"
                                     v-model="agencyParam"
                                     :required="true"
                                     :placeholder="placeholders.agency"
                                     :tabindex="1"></select2>

                        </div>
                    </div>
                    <div class="col-sm-4"
                         v-if="customersWithStatus && customersWithStatus.length">
                        <div class="form-group form-group-default required">
                            <label>Client</label>
                            <select2 :classList="['full-width', 'form-control']"
                                     :options="customersWithStatus"
                                     v-model="customerParam"
                                     :required="true"
                                     :placeholder="placeholders.customer"
                                     :tabindex="2"></select2>

                        </div>
                    </div>
                    <div class="col-sm-4"
                         v-if="renderOfferSelect">
                        <div class="form-group form-group-default required">
                            <label>Produit</label>
                            <select2 :classList="['full-width', 'form-control']"
                                     :options="offers"
                                     v-model="offerParam"
                                     :required="true"
                                     :placeholder="placeholders.offer"
                                     :tabindex="3"></select2>
                        </div>
                    </div>
                </div>

                <div class="row"
                     v-if="anyDefaultPriceList">
                    <div class="form-group form-group-default required">
                        <label>Tarification</label>
                        <select2 :classList="['full-width', 'form-control']"
                                 :options="defaultPriceList"
                                 @input="choosePriceList"
                                 :required="true"
                                 :placeholder="placeholders.default_price_list"
                                 :tabindex="4"></select2>

                    </div>
                </div>

                <div class="row clearfix"
                     v-if="anyPriceList">
                    <div class="col-sm-4">
                        <div class="form-group form-group-default required">
                            <label>Prix</label>
                            <input type="text"
                                   id="unit_price"
                                   tabindex="5"
                                   :disabled="!canEditPrice"
                                   v-model.number="sendData.unit_price"
                                   data-a-sign="€ "
                                   data-a-dec=","
                                   data-a-sep="."
                                   class="form-control">
                        </div>
                    </div>
                    <div class="col-sm-4">
                        <div class="form-group form-group-default required">
                            <label>Quantité (unité: {{priceList.unit_text}})</label>
                            <input type="text"
                                   v-model.number="sendData.quantity"
                                   tabindex="6"
                                   class="form-control"
                                   required>
                        </div>
                    </div>
                    <div class="col-sm-4">
                        <div class="form-group form-group-default">
                            <label>Réference</label>
                            <input type="text"
                                   v-model="sendData.reference"
                                   maxlength="16"
                                   tabindex="7"
                                   class="form-control">
                        </div>
                    </div>
                </div>

            </div>
            <div class="row p-t-10"
                 v-if="anyPriceList">
                <div class="col-md-4">
                    <div class="form-group form-group-default required">
                        <label>Date</label>
                        <input type="text"
                               id="consumption_date"
                               :value="sendData.consumption_date"
                               tabindex="8"
                               class="form-control"
                               required>
                    </div>
                </div>
                <div class="col-sm-4 p-l-20">
                    <p>
                        <span class="bold">Total: </span>
                        <span v-html="`${totalPrice/100} €`"></span>
                    </p>
                </div>
                <div class="col-sm-4 p-t-30">
                    <button type="submit"
                            class="btn btn-primary btn-sm"
                            @click.prevent="handleSubmit">Ajouter</button>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    import Select2 from 'components/Form/Select2'
    import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
    import { PARAMS_CHANGED, PRICE_LIST_CHOSEN } from 'store/mutation-types'
    import ErrorNotification from 'components/ConsumptionProducts/ErrorNotification'

    export default {
        components: {
            Select2,
            ErrorNotification
        },

        data () {
            return {
                placeholders: {
                    agency: 'Choisir agence',
                    customer: 'Choisir un client',
                    offer: 'Choisir un produit',
                    default_price_list: 'Choisir la tarification'
                },
                sendData: {
                    free_price: false,
                    price: "",
                    quantity: "",
                    reference: "",
                    unit: null,
                    unit_price: null,
                    consumption_date: moment().format('YYYY-MM-DD')
                }
            }
        },

        created () {
            this.$watch(function () {
                return !_.isEmpty(this.priceList) && this.uid
            }, function () {
                console.info('uid incremented!')
                //$('#consumption_date', this.$el).datepicker('hide').datepicker('destroy')
                const isFreePrice = this.flag === 0

                this.sendData.free_price = isFreePrice
                this.sendData.unit_price = isFreePrice ? 1 : Number(this.priceList.base_price) / 100
                this.sendData.quantity = Number(this.priceList.base_quantity)
                this.sendData.reference = ""
                this.sendData.unit = this.priceList.unit
                this.sendData.consumption_date = moment().format('YYYY-MM-DD')
                this.$nextTick()
                    .then(() => {
                        $('#consumption_date', this.$el).datepicker({
                            format: "yyyy-mm-dd",
                            language: "fr",
                            autoclose: true,
                            // title: "Date de consommation",
                        }).on('changeDate', (e) => {
                            this.sendData.consumption_date = e.target.value
                            //debugger
                            //$(e.target).datepicker('hide')
                        })
                    })
            })
        },

        mounted () {

        },


        methods: {
            ...mapActions('consumptions', [
                'fetchAgencyBasedData',
                'prepareSecondStep',
                'choosePriceList',
                'addConsumption',
                'fetchCustomerMailForwardingPackage'
            ]),

            ...mapMutations('consumptions', {
                updateParams: PARAMS_CHANGED
            }),

            handleSubmit () {
                this.$store.commit('FORM_ERROR', {})
                this.sendData.price = this.totalPrice
                this.addConsumption(this.sendData)
            },

        },

        computed: {
            ...mapState('consumptions', [
                'customers',
                'offers',
                'addParams',
                'priceList',
                'flag',
                'uid',
                'hasActiveMailForwardingPackage'
            ]),

            ...mapGetters(['anyError']),

            ...mapState(['formError']),

            customersWithStatus () {
                return _.map(this.customers, (customer) => {
                    const attr = customer.attributes
                    return {
                        id: customer.id,
                        name: attr.name + " (" + this.getEnumTranslatedValue('customer_status', attr.status) + ') ' + (attr.erp_id ? attr.erp_id : '')
                    }
                })
            },

            renderOfferSelect () {
                return !_.isEmpty(this.offers)
            },

            anyFlag () {
                return !_.isNull(this.flag)
            },

            anyDefaultPriceList () {
                return this.anyFlag
                    && this.flag > 1
                //                    && _.isEmpty(this.priceList)
            },

            anyPriceList () {
                return this.anyFlag
                    && !_.isEmpty(this.priceList)
            },

            canEditPrice () {
                return this.anyFlag && this.flag === 0
            },

            totalPrice () {
                return (this.sendData.unit_price * 100 * this.sendData.quantity)
            },

            ...mapGetters('consumptions', {
                agencies: 'selectAgenciesList',
                defaultPriceList: 'selectDefaultPriceList'
            }),

            agencyParam: {
                get () {
                    return this.addParams.agencies
                }, set (newVal) {
                    this.updateParams({ agencies: newVal })
                    _.isNull(newVal) || this.fetchAgencyBasedData()
                }
            },

            customerParam: {
                get () {
                    return this.addParams.customer_id
                }, set (newVal) {
                    if (_.isNil(newVal))
                        return;
                    this.updateParams({ customer_id: newVal })
                    this.fetchCustomerMailForwardingPackage(newVal)
                    if (_.isEmpty(this.offerParam))
                        return;
                    this.prepareSecondStep()
                }
            },

            offerParam: {
                get () {
                    return this.addParams.offer_id
                }, set (newVal) {
                    if (_.isNil(newVal))
                        return;
                    this.updateParams({ offer_id: newVal })
                    if (_.isEmpty(this.customerParam))
                        return;
                    this.prepareSecondStep()
                    //create Price list / input
                }
            }
        },

        beforeCreate(){
          this.$store.commit('FORM_ERROR', {})
        }

    }
</script>



// WEBPACK FOOTER //
// client/components/ConsumptionProducts/AddForm.vue